import { Routes, Route } from "react-router-dom";

import LogOut from "./Components/Logout";
import ChangePassword from "./Components/ChangePassword";
import MenuHead from "./Components/Dashboard/MenuHead";

export default function LandingPage1() {
  return (
    <Routes>
      <Route path="/MenuHead" element={<MenuHead />} />
      <Route path="/changepasswords" element={<ChangePassword />} />
      <Route path="/Logout.do" element={<LogOut />} />

    </Routes>
  );
}
